import BlockStatistics from "./block-stats";

export default BlockStatistics;